module.exports = {"resetEmail.modal.description":"Please enter your email address. We will send you an email to reset your password. If you do not receive an email, please check your spam/promotions folder and try a different email or sign-in method (Google sign-in, or Apple ID).","resetEmail.modal.action.buttonLabel":"Send Email","resetEmail.action.email.sent":"Please check your email and spam folder. If you have not received an email, you may have used another sign-in method (Google sign-in or Apple ID) or an account does not exist under this email."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/components/ModalContent/ResetEmail.json
// module id = 727
// module chunks = 0